import { CatchAnimBase } from "./AnimBase";
import { AnimSideStep } from "./AnimSideStep";
import { GoalieCatchAnim } from "./Goalie";



/**
 * Animace pro jumpUp2 s posunem entity brankare ve vzduchu (pokud to je potreba)
 */
export class Anim2 extends CatchAnimBase {
    private static readonly AIR_MOVE_START_TIME = 15 / 30;
    private static readonly AIR_MOVE_END_TIME = 35 / 30;
    private static readonly AIR_MOVE_MAX_DIS = 1.25;
    private static readonly AIR_MOVE_DEF_DIS = 0.7;

    private static readonly FLAG_AIR_MOVE = 2;

    private _airMoveDis: number;
    private _airMoveStartX: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    init(ballPos: pc.Vec2, ballTime: number, data: GoalieCatchAnim): void {
        this._flags = 0;

        // Cas spusteni animace
        this._animStartTime = ballTime - data.animTimeOffset;

        // Horizontalni posun pres "side step" animaci
        let goaliePos = this._goalie.entity.getPosition();
        let hDis = ballPos.x - goaliePos.x;
        let noMoveZoneX = goaliePos.x + data.noHMoveZone.originX * (hDis < 0 ? -1 : 1);

        this._airMoveDis = 0;

        if (ballPos.x < noMoveZoneX - data.noHMoveZone.halfWidth || ballPos.x > noMoveZoneX + data.noHMoveZone.halfWidth) {
            let groundMoveDis = Math.abs(ballPos.x - noMoveZoneX);
            let minGroundMoveDis = (AnimSideStep.SPEED * AnimSideStep.ANIM_LEN) / 2;

            this._airMoveDis = Math.min(groundMoveDis, Anim2.AIR_MOVE_MAX_DIS / 2);

            if ((groundMoveDis -= this._airMoveDis) < minGroundMoveDis && this._airMoveDis > Anim2.AIR_MOVE_DEF_DIS / 2) {
                let i = Math.min(this._airMoveDis - Anim2.AIR_MOVE_DEF_DIS / 2, minGroundMoveDis - groundMoveDis);

                this._airMoveDis -= i;
                groundMoveDis += i;
            }

            if (hDis < 0) {
                this._airMoveDis *= -1;
                groundMoveDis *= -1;
            }

            this._airMoveDis *= 2;

            if (groundMoveDis != 0)
                // Posun brankare pres "side step" animaci
                this._goalie.moveToSide(groundMoveDis, this._animStartTime)
        }

        // Jmeno animace
        this._animName = data.animName + (hDis > 0 ? "L" : "R");
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        super.update();

        if ((this._flags & CatchAnimBase.FLAG_ANIM_RUNNING) != 0 && this._airMoveDis != 0) {
            let entity = this._goalie.entity;
            let animTime = entity.animation.currentTime;

            if (this._airMoveDis != 0 && animTime >= Anim2.AIR_MOVE_START_TIME) {
                if ((this._flags & Anim2.FLAG_AIR_MOVE) == 0) {
                    this._flags |= Anim2.FLAG_AIR_MOVE;
                    this._airMoveStartX = entity.getPosition().x;
                }

                let progress = (animTime - Anim2.AIR_MOVE_START_TIME) / (Anim2.AIR_MOVE_END_TIME - Anim2.AIR_MOVE_START_TIME);

                if (progress > 1)
                    progress = 1;

                let pos = entity.getPosition();

                pos.x = this._airMoveStartX + this._airMoveDis * progress;
                entity.setPosition(pos);

                if (progress == 1)
                    this._airMoveDis = 0;
            }
        }
    }
}